export default {
  async validate(endpoint, token)
  {
    try {
      // STEP 1: Fetch public key from JWKS endpoint
      const jwksResponse = await fetch(endpoint);

      if (!jwksResponse.ok) {
        throw new Error('Failed to fetch JWK');
      }

      const jwksData = await jwksResponse.json();

      // STEP 2: Decode JWT header to get key ID (kid)
      const [headerB64] = token.split('.');
      const header = JSON.parse(atob(headerB64));

      // STEP 3: Find matching key in JWK set
      const key = jwksData.keys?.find(k => k.kid === header.kid);

      if (!key) {
        throw new Error('No matching key found in JWK');
      }

      const cryptoKey = await crypto.subtle.importKey(
        'jwk',
        key,
        { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' },
        false,
        ['verify']
      );

      // STEP 5: Verify signature
      const headerPayloadB64 = token.split('.').slice(0, 2).join('.');
      const signatureB64 = token.split('.')[2];

      const encoder = new TextEncoder();
      const data = encoder.encode(headerPayloadB64);
      const signature = Uint8Array.from(atob(signatureB64.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));

      const isValid = await crypto.subtle.verify(
        'RSASSA-PKCS1-v1_5',
        cryptoKey,
        signature,
        data
      );

      // STEP 6: Also check token expiration
      const [, payloadB64] = token.split('.');
      const payload = JSON.parse(atob(payloadB64));
      const now = Math.floor(Date.now() / 1000);

      if (payload.exp && payload.exp < now) {
        console.error('[JWT] Token expired');
        return false;
      }

      return isValid;

    } catch (error) {
      console.error('[JWT] Validation error:', error);
      return false;
    }
  }
}
